import React from 'react'
import AutoForm from 'App/components/AutoForm'
import useMessage from 'App/hooks/useMessage'
import gql from 'graphql-tag'
import useMutate from 'apollo-hooks/lib/useMutate'
import {sortAgents} from 'src/App/Pages/Inbox/helpers'
import AgentList from './AgentList'
import styles from './styles.css'
import {useInboxConfiguration, useAgents} from './hooks'

export default function InboxConfiguration() {
  const showMessage = useMessage()
  const mutate = useMutate()

  const {configuration} = useInboxConfiguration()

  const {agents} = useAgents()

  async function updateUserActiveForAutoAssignChat({userId, activeForAutoAssignChat}) {
    try {
      await mutate({
        mutation: gql`
          mutation updateUserActiveForAutoAssignChat(
            $userId: ID
            $activeForAutoAssignChat: Boolean
          ) {
            updateUserActiveForAutoAssignChat(
              userId: $userId
              activeForAutoAssignChat: $activeForAutoAssignChat
            ) {
              _id
            }
          }
        `,
        variables: {userId, activeForAutoAssignChat},
        refetchQueries: ['getAgents']
      })
      showMessage('Usuario actualizado')
    } catch (error) {
      showMessage(error)
    }
  }

  const activeAgents = (agents || []).sort(sortAgents)

  return (
    <div className={styles.configuration}>
      <h2>Configurar balanceador de chats</h2>
      <AutoForm
        mutation="updateInboxConfiguration"
        doc={configuration}
        omit="configurationId"
        onSuccess={() => showMessage('Información actualizada')}
        autoSave
      />
      <AgentList agents={activeAgents} onToggleClick={updateUserActiveForAutoAssignChat} />
    </div>
  )
}
